import { UserNotification } from "../@types/Users";
import {
  findOne,
  findMany,
  destroy,
  maskAsRead,
} from "../services/notifications";
import useAuth from "./useAuth";

export default function useNotifications() {
  const { isAuthenticated } = useAuth();

  function show(id: number): Promise<UserNotification | undefined> {
    return findOne(id);
  }

  function getAll(qnt: number): Promise<UserNotification[]> {
    const isAuth = isAuthenticated();

    if (isAuth) {
      return findMany(qnt);
    }

    return Promise.resolve([] as UserNotification[]);
  }

  async function markRead(id: number): Promise<boolean> {
    const status = await maskAsRead(id);

    if (status === 200) {
      return true;
    }

    return false;
  }

  async function moveToJunk(id: number): Promise<boolean> {
    const status = await destroy(id);

    if (status === 200) {
      return true;
    }

    return false;
  }

  return { show, getAll, markRead, moveToJunk };
}
